import React from 'react';
import { Calendar } from 'lucide-react';
import { Input } from '../ui/input';
import { Toggle } from '../ui/toggle';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Section, FormField } from './InspectionShared';

const HeaderSection = ({ formData, setFormData, toggleArray, beekeepers, weatherLoading, weatherAutoFetched }) => {
  return (
    <Section title="Header Information" icon={<Calendar className="h-6 w-6 text-blue-600" />}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField label="Date" required>
          <Input
            type="date"
            value={formData.date}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
            data-testid="date-input"
            className="h-14"
          />
        </FormField>
        <FormField label="Time">
          <Input
            type="time"
            value={formData.time}
            onChange={(e) => setFormData({ ...formData, time: e.target.value })}
            data-testid="time-input"
            className="h-14"
          />
        </FormField>
        <FormField label="Beekeeper">
          <Select
            value={formData.beekeeper}
            onValueChange={(value) => setFormData({ ...formData, beekeeper: value })}
          >
            <SelectTrigger className="h-14" data-testid="beekeeper-select">
              <SelectValue placeholder="Select beekeeper" />
            </SelectTrigger>
            <SelectContent>
              {beekeepers.map((beekeeper) => (
                <SelectItem key={beekeeper.id} value={beekeeper.name}>
                  {beekeeper.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FormField>
        <FormField label={
          <span className="flex items-center gap-2">
            Temperature
            {weatherLoading && (
              <span className="text-xs text-blue-500 animate-pulse">Fetching...</span>
            )}
            {weatherAutoFetched && !weatherLoading && (
              <span className="text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">Auto</span>
            )}
          </span>
        }>
          <Input
            value={formData.temperature}
            onChange={(e) => setFormData({ ...formData, temperature: e.target.value })}
            placeholder="e.g., 72°F"
            data-testid="temperature-input"
            className="h-14"
          />
        </FormField>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField label={
          <span className="flex items-center gap-2">
            Humidity
            {weatherAutoFetched && !weatherLoading && formData.humidity && (
              <span className="text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">Auto</span>
            )}
          </span>
        }>
          <Input
            placeholder="e.g., 65%"
            value={formData.humidity || ''}
            onChange={(e) => setFormData({ ...formData, humidity: e.target.value })}
            data-testid="humidity-input"
            className="h-14"
          />
        </FormField>
        <FormField label={
          <span className="flex items-center gap-2">
            Wind
            {weatherAutoFetched && !weatherLoading && formData.wind && (
              <span className="text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">Auto</span>
            )}
          </span>
        }>
          <Input
            placeholder="e.g., 15 km/h, Light breeze"
            value={formData.wind || ''}
            onChange={(e) => setFormData({ ...formData, wind: e.target.value })}
            data-testid="wind-input"
            className="h-14"
          />
        </FormField>
      </div>
      <FormField label={
        <span className="flex items-center gap-2">
          Weather
          {weatherAutoFetched && !weatherLoading && formData.weather.length > 0 && (
            <span className="text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">Auto</span>
          )}
        </span>
      }>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {['Sunny', 'Cloudy', 'Partly Cloudy', 'Light Rain', 'Heavy Rain', 'Dry', 'High Pollen Count'].map((w) => (
            <Toggle
              key={w}
              pressed={formData.weather.includes(w)}
              onPressedChange={() => toggleArray('weather', w)}
              data-testid={`weather-${w.toLowerCase().replace(' ', '-')}`}
              className="h-16 data-[state=on]:bg-lime-600 data-[state=on]:text-white"
            >
              {w}
            </Toggle>
          ))}
        </div>
      </FormField>
    </Section>
  );
};

export default HeaderSection;
